import { Button } from '@/components/ui/button';
import { Target, Activity, TrendingDown, Calendar, Trash2 } from 'lucide-react';

interface QuickActionChipsProps {
  onSelect: (prompt: string) => void;
}

const quickActions = [
  { label: "What should I do today?", icon: Target },
  { label: "Audit my business health", icon: Activity },
  { label: "Why isn't revenue moving?", icon: TrendingDown },
  { label: "Review my last week", icon: Calendar },
  { label: "Clean up stale items", icon: Trash2 },
];

export function QuickActionChips({ onSelect }: QuickActionChipsProps) {
  return (
    <div className="space-y-2">
      <p className="text-xs text-muted-foreground text-center">Quick questions</p>
      <div className="flex flex-wrap gap-2 justify-center">
        {quickActions.map((action) => {
          const Icon = action.icon;
          return (
            <Button
              key={action.label}
              variant="outline"
              size="sm"
              onClick={() => onSelect(action.label)}
              className="h-auto py-2 px-3 text-xs font-normal whitespace-normal text-left"
            >
              <Icon className="h-3.5 w-3.5 mr-1.5 shrink-0" />
              {action.label}
            </Button>
          );
        })}
      </div>
    </div>
  );
}
